import React from "react";
import ReactDOM from "react-dom";
import App from "./Components/App";

//REDUX
import { Provider } from "react-redux";
import dataStore from "./configureStore";

//Styles!
import "./style/index.css";

ReactDOM.render(
  <Provider store={dataStore}>
    <App />
  </Provider>,
  document.getElementById("root")
);
